
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[ssgParams]/products/pages",
      function () {
        return require("private-next-pages/[ssgParams]/products/pages.ts");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[ssgParams]/products/pages"])
      });
    }
  